<template>
    <div class="my">
        <div class="title2" style="margin-top: 0px;">{{ $t("my.myProfit") }}</div>
        <div class="node-bonus">
            <div class="datas">
                <div class="bonus-data">
                    <span>{{convertDown(myData.pledgeRemainProfit-myData.pledgeCurProfit)}}</span>
                    <span>{{ $t("my.pledgeTotal") }} (USDT)</span>
                </div>
                <div class="bonus-data">
                    <span>{{convertDown(myData.pledgeWaitProfit+myData.pledgeCurProfit)}}</span>
                    <span>{{ $t("my.pledgeWait") }} (USDT)</span>
                </div>
            </div>
            <div class="datas" style="margin-top: 20px;">
                <div class="bonus-data">
                    <span>{{convertDown(myData.nodeRemainProfit-myData.nodeCurProfit)}}</span>
                    <span>{{ $t("my.nodeTotal") }} (MPC)</span>
                </div>
                <div class="bonus-data">
                    <span>{{convertDown(myData.nodeCurProfit)}}</span>
                    <span>{{ $t("my.nodeWait") }} (MPC)</span>
                </div>
            </div>
            <div class="func" @click="confirmTakeProfit">{{ $t("my.exchange") }}</div>
        </div>

        <div class="title2">{{$t("my.myInviteUrl")}}</div>
        <div class="myProfitRight">
            <div class="url-func" v-clipboard:copy="myInviteUrl" v-clipboard:success="onCopy">
                <span>{{myInviteUrl}} <i class="el-icon-document-copy"/></span>
            </div>
        </div>
        <div class="title2">{{$t("my.bindCode")}}</div>
        <div class="myProfitRight">
            <div class="url-func" v-clipboard:copy="myParent" v-clipboard:success="onCopy" v-if="myParent">
                <span>{{myParent}}<i class="el-icon-document-copy"/></span>
            </div>
            <div class="url-func" v-clipboard:copy="myParent" v-clipboard:success="onCopy" v-else>
                <span>{{$t("my.notBind")}}</span>
            </div>
        </div>
        <div class="title2">{{$t("my.myTeam")}}</div>
        <div class="myTeam">
            <div class="listHeader">
                <span>{{$t("my.address")}}</span>
                <span>{{$t("my.time")}}</span>
                <span>{{$t("my.buyVal")}}(USDT)</span>
            </div>
            <div class="listBody" v-if="inviteList && inviteList.length>0">
                <div v-for="(item,index) in inviteList" :key="index">
                    <!-- <span>{{showAddress(item.relation.target)}} <i>({{ item.actived?$t("my.hasActive"):$t("my.notActive") }})</i></span> -->
                    <span>{{showAddress(item.relation.target)}}</span>
                    <span>{{formatTimestamp(item.relation.time*1000)}}</span>
                    <span>{{showDataAuto(convertFromByUnit(item.buyVal,18))}}</span>
                </div>
            </div>
            <div class="noData" v-else>
                <img src="@/assets/images/qai/empty.png"/>
                <span>{{$t('common.noData')}}</span>
            </div>
        </div>
        <div class="title2">{{$t("my.aboutUs")}}</div>
        <div class="links">
            <div @click="choosed('Telegram')">
                <img src="@/assets/images/mpc/telegram.png"/>
                <span>Telegram</span>
            </div>
            <div @click="choosed('Twitter')">
                <img src="@/assets/images/mpc/x.png"/>
                <span>X(Twitter)</span>
            </div>
            <div @click="choosed('Foundation')">
                <img src="@/assets/images/mpc/jjh.png"/>
                <span>{{$t("my.foundation")}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import bus from '@/assets/js/bus';
import { getUserName} from '@/assets/js/user';
import Web3 from 'web3';
export default {
	data() {
		return {
            walletAddress: "",
            web3Instance:null,
            mpcTeamContractInstance:null,
            mpcHomeContractInstance:null,
            myData:{
                pledgeRemainProfit:0,
                pledgeWaitProfit:0,
                pledgeCurProfit:0,
                nodeRemainProfit:0,
                nodeCurProfit:0,
            },

            myInviteUrl:"",
            myParent:"",
            inviteList:[],
		};
	},
    created() {
        bus.$off('clearWalletAddress');
        bus.$off('refreshWalletData');
        bus.$on('clearWalletAddress',function(){
            this.web3Instance = null;
            this.mpcTeamContractInstance = null;
            this.mpcHomeContractInstance = null;
        });
        bus.$on('refreshWalletData',async function() {
            this.walletAddress = getUserName();
            this.myInviteUrl = `${window.location.protocol}//${window.location.host}?code=${this.walletAddress}`;
            this.initWallet();
        });
    },
    mounted() {
        if(getUserName()){
            this.hideConnectWalletBox();
            this.walletAddress = getUserName();
            this.myInviteUrl = `${window.location.protocol}//${window.location.host}?code=${this.walletAddress}`;
            this.initWallet();
        }else{
            this.showConnectWalletBox();
            this.connectWallet();
        }
    },
    methods: {
        choosed(command){
            if(command == "Telegram"){
                window.open("https://t.me/MetaPaymentChain","_blank");
            }else if(command == "Twitter"){
                window.open("https://x.com/MPCPaymenttz","_blank");
            }else if(command == "Foundation"){
                window.open(`${window.location.protocol}//${window.location.host}/foundation.pdf`,"_blank");
            }
        },
        initWallet(){
            this.web3Instance = new Web3(window.ethereum);
            this.mpcTeamContractInstance = new this.web3Instance.eth.Contract(this.MpcTeam_Contract.abi, this.MpcTeam_Contract.address);
            this.mpcHomeContractInstance = new this.web3Instance.eth.Contract(this.MpcHome_Contract.abi, this.MpcHome_Contract.address);
            this.tokenMpcContractInstance = new this.web3Instance.eth.Contract(this.TokenMpc_Contract.abi, this.TokenMpc_Contract.address);
            this.refreshWalletData();
        },
        refreshWalletData(){
            this.showLoadingBox();
            this.tokenMpcContractInstance.methods.balanceOf(this.MpcHome_Contract.address).call().then((result) => {
                let homePoolMpcBalance = this.convertFromByUnit(result,18);
                console.log("homePoolMpcBalance:",homePoolMpcBalance);
            });
            this.mpcHomeContractInstance.methods.findUserProfit(this.walletAddress).call().then((result) => {
                this.hideLoadingBox();
                this.myData = {
                    pledgeRemainProfit:this.convertFromByUnit(result.pledgeRemainProfit,18),
                    pledgeWaitProfit:this.convertFromByUnit(result.pledgeWaitProfit,18),
                    pledgeCurProfit:this.convertFromByUnit(result.pledgeCurProfit,18),
                    nodeRemainProfit:this.convertFromByUnit(result.nodeRemainProfit,18),
                    nodeCurProfit:this.convertFromByUnit(result.nodeCurProfit,18),
                }
                console.log("result:",this.myData);
            });
            this.mpcHomeContractInstance.methods.findUserChildDetailList(this.walletAddress).call().then((result) => {
                this.inviteList = result;
            });
            this.mpcTeamContractInstance.methods.findUserParent(this.walletAddress).call().then((result) => {
                if(result != "0x0000000000000000000000000000000000000000"){
                    this.myParent = result;
                }else{
                    this.myParent = "";
                }
            });
        },
        async confirmTakeProfit(){
            let _this = this;
            if(!this.mpcHomeContractInstance){
                return;
            }
            if((this.myData.pledgeWaitProfit+this.myData.pledgeCurProfit) == 0 && this.myData.nodeCurProfit == 0){
                this.$message.warning({message: this.$t('my.noProfit'),duration: 1500})
                return;
            }
            let method = this.mpcHomeContractInstance.methods.takeProfit();
            let bnbAmount = null;
            let gasprice = await this.web3Instance.eth.getGasPrice();
            console.log("gasPrice:",gasprice);
            method.estimateGas({from: this.walletAddress, value:bnbAmount}).then(function(result){
                console.log("estimateGas:",result);
            }).catch((err) => {
                console.log("estimateGas:",err)
            });
            this.showConfirmBox();
            this.contractSend(method,this.walletAddress,bnbAmount).then(function(result){
                _this.hideConfirmBox();
                if(result.status){
                    _this.refreshWalletData();
                    _this.$message.success({message: _this.$t('my.exchangeSuccess'),duration: 1500});
                }else{
                    _this.$message.error({message: _this.$t('my.exchangeFail'),duration: 1500});
                }
            }).catch((err) => {
                _this.hideConfirmBox();
                _this.$message.error({message: _this.$t('my.exchangeFail'),duration: 1500});
            });
        },
    },
    beforeDestroy() {
    }
};
</script>
<style lang='less' scoped>
.my{
    padding-top: 10px;
    padding-bottom: 50px;
    .node-bonus{
        margin:0px 10px;
        padding: 25px 20px 30px 20px;
        background:url('~@/assets/images/mpc/bg-bonus.png') 0px 0px no-repeat;
        background-size: 100% 100%;
        .datas{
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .bonus-data{
            display: flex;
            flex-direction: column;
            span:first-child{
                font-weight: bolder;
                font-size: 25px;
                color: #FFFFFF;
            }
            span:last-child{
                font-size: 13px;
                // color: #747A9A;
                color: #9ABCDF;
            }
        }
        .bonus-data:first-child{
            align-items: flex-start;
        }
        .bonus-data:last-child{
            align-items: flex-end;
        }
        .func {
            margin-top: 25px;
            font-size: 14px;
            height: 45px;
            line-height: 45px;
            color:#000000;
            text-align: center;
            cursor: pointer;
            background:url('~@/assets/images/mpc/bg-btn.png') 0px 0px no-repeat;
            background-size: 100% 100%;
        }
    }

    .myProfitRight{
        margin: 0px 10px;
        padding: 18px 20px;
        background:url('~@/assets/images/mpc/bg-msg.png') 0px 0px no-repeat;
        background-size: 100% 100%;
        color: #ffffff;
        .url-func{
            display: flex;
            align-items: center;
            cursor:pointer;
            span{
                text-align: left;
                word-break: break-all;
                font-size:13px;
                line-height:20px;
                color:#9ABCDF;
            }
            i{
                font-size:12px;
                margin-left:5px;
                color: #00CCFF;
            }
        }
    }

    .myTeam{
        margin: 0px 10px;
        padding: 18px 20px;
        background:url('~@/assets/images/mpc/bg-msg.png') 0px 0px no-repeat;
        background-size: 100% 100%;
        color: #ffffff;
        .listHeader{
            font-size: 13px;
            color: #9ABCDF;
            margin-bottom: 10px;
            padding-bottom: 8px;
            border-bottom: 1px solid rgba(200,200,200,0.5);
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-align: left;
            span:first-child{
                text-align: left;
                width: 100px;
            }
            span:nth-child(2){
                text-align: center;
                width: 130px;
            }
            span:last-child{
                text-align: right;
                flex:1;
            }
        }
        .listBody{
            div{
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 13px;
                margin-bottom: 12px;
                color:#ffffff;
                span:first-child{
                    text-align: left;
                    width: 100px;
                    i{
                        font-style: normal;
                        color: #30D6FF;
                    }
                }
                span:nth-child(2){
                    text-align: left;
                    width: 130px;
                }
                span:last-child{
                    text-align: right;
                    flex:1;
                    color: #30D6FF;
                }
            }
        }
    }
    
    .links{
        margin: 00px 15px 20px 15px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap:20px;
        div{
            display: flex;
            align-items: center;
            cursor: pointer;
            img{
                width: 22px;
                height: 22px;
                border-radius: 100%;
                margin-right: 5px;
            }
            span{
                font-size: 13px;
                color: #00CCFF;
                // color: #ffffff;
                text-decoration: underline;
            }
        }
    }
}
</style>